<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right d-flex align-items-center " >
            <div class="row mb-2 ">
              <label for="date" class="col-md-4 form-label">
                  From Date
                 
              </label>
              <div class="col-md-8">
                  <flat-pickr v-model="schedule.from_date" class="form-control"
                      @on-change="changeFromDate(schedule.from_date, schedule.to_date)"
                      placeholder="Select From Date" name="date" :config="flatPickrDateConfig">
                  </flat-pickr>
              </div>
            </div>
            <div class="row mb-2 ms-2">
                <label for="date" class="col-md-4 form-label">
                    To Date
                    
                </label>
                <div class="col-md-8">
                    <flat-pickr v-model="schedule.to_date" class="form-control"
                        @on-change="changeToDate(schedule.from_date, schedule.to_date)"
                        placeholder="Select To Date" name="date" :config="flatPickrDateConfig">
                    </flat-pickr>
                </div>
            </div>

            <div @click="refreshData" class="icon-css">
              <i style="color: #4a81d4" class="fe-rotate-cw"></i>
            </div>
          </div>
          <h4 class="page-title">Orientation Assessment</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
          
          <div class="mb-4">
            <!-- advance serach -->
            <div class="d-flex">
              <div class="d-flex flex-column me-2">
                <label class="col-form-label">Program</label>
                <div style="width: 250px">
                  <v-select
                    label="name"
                    v-model="program"
                    :options="programs"
                    :clearable="false"
                    :selectable="
                      (options) => program.short_name != options.short_name
                    "
                    @option:selected="findBatch_programFilter(program)"
                  >
                  </v-select>
                </div>
              </div>
              <div class="d-flex flex-column me-2">
                <label class="col-form-label">Batch</label>
                <div style="width: 180px">
                  <v-select
                    label="batch_no"
                    v-model="batch"
                    :options="batchs"
                    :clearable="false"
                    :selectable="(options) => batch.id != options.id"
                    @option:selected="FilterData(program, batch)"
                  >
                  </v-select>
                </div>
              </div>
              <div class="d-flex mt-4">
                <!-- <div class="col-form-label d-none">hfhd</div> -->
                <div @click="refreshData()" class="icon-css">
                  <i style="color: #4a81d4" class="fe-rotate-cw"></i>
                </div>
              </div>
            </div>
            <!--end advance serach -->

            <div class="d-flex justify-content-end">
              <router-link :to="{ name: 'hrd-orientation-evaluation-create' }">
                <button
                  v-show="!loading"
                  type="button"
                  class="btn btn-sm btn-blue waves-effect waves-light"
                  v-if="hasPermissions(['hrd-orientation-evaluation-create'])"
                >
                  <i class="mdi mdi-plus-circle"></i> Add Record
                </button>
              </router-link>
            </div>
          </div>  
            <place-holder v-if="loading"></place-holder>
            <div class="table-responsive" v-if="!loading">
              <table
                class="table table-striped dt-responsive w-100 mb-3"
                id="orientation-evaluation-list-datatable"
                v-if="!loading"
              >
                <thead v-if="!loading">
                  <tr>
                    <th>No.</th>
                    <th>Employee Name</th>
                    <th>Program Name</th>
                    <th>Batch</th>
                    <th>Achievement</th>
                    <th>Assessment Result</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody v-if="!loading">
                  <template
                    v-for="(item, index) in orientationEvaluation"
                    :key="index"
                  >
                    <tr>
                      <td>{{ ++index }}</td>
                      <td>{{ item.behavior_assessment_detail?.employee.name }}</td>
                      <td>{{ item.behavior_assessment_detail?.program.title }}</td>
                      <td>{{ item.behavior_assessment_detail?.batch_detail.batch_no }}</td>
                      <td>{{ item.achievement }}</td>
                      <td>{{ item.assessment_result }}</td>
                      <td>
                        <span>
                          <router-link
                            class="action-icon"
                            :to="{
                              name: 'hrd-orientation-evaluation-update',
                              params: { id: item.id },
                            }"
                          >
                            <i class="mdi mdi-square-edit-outline"></i>
                          </router-link>
                        </span>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <!-- <div class="text-center" v-if="orientationEvaluation.length == 0">There is no data in table.</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Datatable Program Allocation
import "datatables.net/js/jquery.dataTables.min.js";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-bs5/js/dataTables.bootstrap5.min.js";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-responsive-bs5/js/responsive.bootstrap5.min.js";
import $ from "jquery";
import axios from "axios";
import { useToast } from "vue-toastification";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
//Mixins
import userHasPermissions from "../../../mixins/userHasPermissions";

export default {
  components: {
    vSelect,
    flatPickr,
  },
  mixins: [userHasPermissions],
  setup() {
    const toast = useToast();

    return { toast };
  },
  data() {
    return {
      orientationEvaluation: [],
      year: "",
      yearId: "",
      years: [],
      months: [],
      month: "",
      programs: this.$store.getters["odoo/getAllPrograms"],
      batchs: [],
      program: "",
      batch: "",
      loading: false,
      baseUrl: process.env.VUE_APP_BASE_URL,
       
      flatPickrDateConfig: {
          minDate: null,
          maxDate: null,
          defaultDate: null,
      },
      flatPickrDateConfigLimit: {
          minDate: null,
          maxDate: null,
          defaultDate: null,
      },
      flatPickrTimeConfig: {
          enableTime: true,
          noCalendar: true,
          defaultTime: "08:00:00",
          dateFormat: "H:i:s",
          altInput: true,
          altFormat: "H:i",
          minTime: "08:00",
          maxTime: "17:00",
      },
      schedule: {
          from_date: "",
          to_date: "",
      },
    };
  },
  methods: {
    
    async getOrientationEvaluation() {
      this.loading = true;
      this.$Progress.start();
      let url;

      if(this.schedule.from_date && this.schedule.to_date){
        url = `${this.baseUrl}admin/v2/hrd-orientation-evaluation?from_date=${this.schedule.from_date}&to_date=${this.schedule.to_date}`;
      }else if(this.schedule.from_date){
        url = `${this.baseUrl}admin/v2/hrd-orientation-evaluation?from_date=${this.schedule.from_date}`;
      }else{
        url = `${this.baseUrl}admin/v2/hrd-orientation-evaluation`;
      }

      await axios
        .get(url)
        .then((response) => {
          this.orientationEvaluation = response.data.data;
          this.loading = false;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.error = error.response;
          this.toast.error("Something went wrong.");
          this.loading = false;
        });
      $("#orientation-evaluation-list-datatable").DataTable().draw();
    },
    async findBatch_programFilter(program) {
      this.batch = "";
      this.loading = true;
      await axios
        .get(`${this.baseUrl}admin/v1/program-batches/list?program_id=${program.id}`)
        .then((response) => {
          this.batchs = response.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.toast.error("Not Found Batch!");
        });

      this.clearFilter();
      $.fn.dataTable.ext.search.push(function (settings, data) {
        const check_program = program?.name == data[2] ? true : false;
        console.log("checl-prog", check_program);
        return check_program ? 1 : 0;
      });
      $("#orientation-evaluation-list-datatable").DataTable().draw();
    },
    FilterData(program, batch) {
      this.clearFilter();
      // alert('reach');
      $.fn.dataTable.ext.search.push(function (settings, data) {
        const check_program = program?.name == data[2] ? true : false;
        const check_batch = batch?.batch_no == data[3] ? true : false;

        return check_program && check_batch ? true : false;
      });
      $("#orientation-evaluation-list-datatable").DataTable().draw();
    },
    refreshData() {
      this.orientationEvaluation = [];
      this.year = "";
      this.yearId = "";
      this.years = [];
      this.months = [];
      this.month = "";
      this.batchs = [];
      this.batch = "";
      this.program = "";
      this.schedule.from_date = '';
      this.schedule.to_date = '';
      this.clearFilter();
      this.getOrientationEvaluation();
    },

    clearFilter() {
      $.fn.dataTable.ext.search.pop();
      $("#orientation-evaluation-list-datatable").DataTable().draw();
    },
    changeFromDate(from_date, to_date) {
      this.schedule.from_date = from_date;
      this.schedule.to_date = to_date;
      this.getOrientationEvaluation();
    },

    changeToDate(from_date, to_date) {
      this.schedule.from_date = from_date;
      this.schedule.to_date = to_date;
      this.getOrientationEvaluation();
    },
  },
  created() {
    this.clearFilter();
    this.getOrientationEvaluation();
  },
};
</script>

<style>
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #4a81d4;
  border-color: #4a81d4;
}
.status {
  padding: 0.4em;
}
</style>
